import { createFileRoute } from "@tanstack/react-router";
import { Prose } from "@/components/site/PageHeader";
import { EditablePageShell } from "@/components/site/EditablePageShell";
import { pageQueryOptions } from "@/lib/pages.functions";

export const Route = createFileRoute("/legal/terms")({
  loader: ({ context }) => context.queryClient.ensureQueryData(pageQueryOptions("legal/terms")),
  head: ({ loaderData }) => ({
    meta: [
      { title: loaderData?.title || "Terms of Service — Glow Long Golf" },
      { name: "description", content: loaderData?.meta_description || "The terms that govern your use of glowlonggolf.com and any purchases made through the site." },
      { property: "og:title", content: loaderData?.title || "Terms of Service — Glow Long Golf" },
      { property: "og:description", content: loaderData?.meta_description || "The terms that govern your use of glowlonggolf.com and any purchases made through the site." },
      { property: "og:url", content: "https://glowlong.lovable.app/legal/terms" },
    ],
    links: [{ rel: "canonical", href: "https://glowlong.lovable.app/legal/terms" }],
  }),
  errorComponent: ({ error }) => <div className="p-8 text-sm text-destructive" role="alert">{error.message}</div>,
  notFoundComponent: () => <div className="p-8 text-sm text-muted-foreground">Not found.</div>,
  component: () => (
    <EditablePageShell slug="legal/terms" defaults={{ eyebrow: "Legal", title: "Terms of Service" }}>
      <Prose>
        <p>By using this site or buying our products, you agree to these terms.</p>
        <h2>Products</h2>
        <p>Glow Long Golf balls are sold as recreational products. We do not claim PGA approval, tournament legality, or specific distance/performance benefits. Glow brightness and duration will vary based on charge source and conditions.</p>
        <h2>Safety</h2>
        <p>Always hit toward open, unobstructed areas. Never aim at people, animals, vehicles, roads, windows, or property. You are responsible for using the product safely.</p>
        <h2>Orders & payments</h2>
        <p>Payments are processed by Stripe. Orders ship from Amazon's fulfillment network. See our Shipping & returns page for details.</p>
        <h2>Limitation of liability</h2>
        <p>To the extent permitted by law, our liability is limited to the price you paid for the product.</p>
      </Prose>
    </EditablePageShell>
  ),
});
